
//  export const BASE_URL_FOXBERRY =  'http://localhost:9901/v1';
//  export const BASE_URL = 'http://localhost:9901/v1';
 export const BASE_URL_FOXBERRY =  'https://backend-training.foxberry.live/v1';
 export const BASE_URL = 'https://backend-training.foxberry.live/v1';



